<template lang="pug">
    MatchMedia(v-slot='{ screenSM }')
        div.post-feed-control(:class="theClass" v-scroll-bottom="scrollBottom")
            div.post-feed-control__head
                div.post-feed-control__head-left
                    div.post-feed-control__post-count
                        span {{ postsCountText }}
                    div.post-feed-control__post-search
                        search-control(v-model="searchText" placeholder="Search Post" @blur="closeSearch" ref="searchControl")
                div.post-feed-control__head-right
                    template(v-if="focusUser")
                        icon-button-control(v-show="!searchEnabled" iconId="search" @click="toggleSearch")
                    template(v-else)
                        icon-toggle-control(v-model="freeContent" iconId="price-tag")
                    icon-button-control(v-if="noFocusUserOrOwner" iconId="plus" @click="createPost")

            div.post-feed-control__posts
                div.post-feed-control__post(v-for="post in posts")
                    post-view(:post="post" @removed="removed(post)")
</template>

<script>
import { mapGetters } from 'vuex'
import { MatchMedia } from 'vue-component-media-queries'
import EventBus from '../../lib/event-bus'
import Events from '../../lib/events'
import postService from '../../services/post-service'

export default {
    name: 'post-feed-control',

    components: {
        MatchMedia,
    },

    props: {
        focusUserId: {
            type: String,
        },
    },

    data() {
        return {
            posts: [],
            postsPage: 0,
            noMorePosts: false,
            totalPostsCount: 0,
            searchEnabled: false,
            searchText: '',
            freeContent: false,
        }
    },

    computed: {
        ...mapGetters(['authUser']),

        focusUser() {
            return !!this.focusUserId
        },

        noFocusUserOrOwner() {
            return !this.focusUserId || this.authUser.id == this.focusUserId
        },

        postsCountText() {
            if (this.totalPostsCount) {
                return `${this.totalPostsCount} Posts`
            }
        },

        theClass() {
            return {
                'post-feed-control--search': this.searchEnabled || !this.focusUser,
            }
        },
    },

    watch: {
        searchText() {
            this.loadPosts()
        },
        freeContent() {
            this.loadPosts()
        },
        focusUserId() {
            this.loadPosts()
        },
    },

    methods: {
        loadPosts(page = 'first') {
            if (page == 'first') {
                this.noMorePosts = false
                this.totalPostsCount = 0
            }

            if (this.noMorePosts) {
                return
            }

            const pageSize = 5

            const pageMap = {
                first: 1,
                same: this.postsPage,
                next: this.postsPage + 1,
            }

            const opt = {
                search: this.searchText,
                freeContent: this.freeContent,
                userId: this.focusUserId,
                page: pageMap[page],
                page_size: pageSize,
            }

            postService.list(opt).then(({ data }) => {
                const posts = data.data
                const postsPage = data.meta.pagination.current_page

                if (posts.length < pageSize) {
                    this.noMorePosts = true
                }

                switch (page) {
                    case 'first':
                        this.posts = posts
                        this.postsPage = postsPage
                        break
                    case 'next':
                        this.posts.push(...posts)
                        this.postsPage = postsPage
                        break
                }
            })

            if (page == 'first' && this.focusUser) {
                postService.count(opt).then(({ data }) => {
                    this.totalPostsCount = data
                })
            }
        },

        removed(post) {
            this.posts.splice(this.posts.findIndex(p => p.id == post.id), 1)
        },

        scrollBottom() {
            this.loadPosts('next')
        },

        toggleSearch() {
            if (this.searchEnabled) {
                this.closeSearch(true)
            }
            else {
                this.searchEnabled = true
                this.$nextTick(this.$refs.searchControl.focus)
            }
        },
        closeSearch(clear) {
            if (clear) {
                this.searchText = ''
            }
            if (!this.searchText) {
                this.searchEnabled = false
            }
        },
        setSearch(search) {
            if (!this.searchEnabled) {
                this.toggleSearch()
            }
            this.searchText = search
        },
        createPost() {
            this.$router.push({ name: 'post-create-edit-page' })
        },
    },

    created() {
        this.loadPosts()
        EventBus.$on(Events.SEARCH_POST, this.setSearch)
    },

    beforeDestroy() {
        EventBus.$off(Events.SEARCH_POST, this.setSearch)
    },
}
</script>
